import { ReactElement } from 'react'

export function NotificationBadge({ showNotification }: { showNotification: boolean }): ReactElement {
  return (
    <div className="absolute -right-[2px] -top-[6px] z-50 flex items-center gap-x-1">
      {showNotification && (
        <div className="flex h-[18px] items-center rounded text-center">
          <div className="h-1.5 w-1.5 rounded-full bg-primary-600" />
        </div>
      )}
    </div>
  )
}
